var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { TimePicker } from '@material-ui/pickers';
import clsx from 'clsx';
import { useAsyncEffect, useAsyncState } from '@hilma/tools';
import { formatTime, getDateTime, errorGenerators } from '../functions';
import { useForm, useLanguage, useBaseI18n } from '../hooks';
import { useStyles as useFormFileStyles } from './FormFile';
import FormInput from './FormInput';
var FormTimeRange = function (_a) {
    var id = _a.id, disabled = _a.disabled, _b = _a.classes, formInputClasses = _b === void 0 ? {} : _b, rest = __rest(_a, ["id", "disabled", "classes"]);
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useAsyncState('first'), currentTime = _d[0], setCurrentTime = _d[1], getCurrentTime = _d[2];
    var _e = useAsyncState(null), firstTime = _e[0], setFirstTime = _e[1], getFirstTime = _e[2];
    var _f = useAsyncState(null), secondTime = _f[0], setSecondTime = _f[1], getSecondTime = _f[2];
    var _g = useState(''), error = _g[0], setError = _g[1];
    var classes = useStyles();
    var formFileClasses = useFormFileStyles();
    var ctr = useBaseI18n(function (i18n) { return i18n.form.chooseTimeRange; });
    var form = useForm();
    var language = useLanguage();
    var range = useMemo(function () { return form.values[id]; }, [form.values[id]]);
    var value = useMemo(function () {
        if (!range)
            return ctr;
        return formatTime(range[0], language) + " - " + formatTime(range[1], language);
    }, [range, language, ctr]);
    var onOpen = useCallback(function () {
        setFirstTime(range ? range[0] : null);
        setSecondTime(range ? range[1] : null);
        setIsOpen(true);
    }, [range]);
    var onCancel = useCallback(function () {
        setIsOpen(false);
    }, []);
    var generateError = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0: return [4 /*yield*/, getFirstTime()];
                case 1:
                    _a = !(_l.sent());
                    if (_a) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSecondTime()];
                case 2:
                    _a = !(_l.sent());
                    _l.label = 3;
                case 3:
                    if (_a)
                        return [2 /*return*/, ''];
                    _b = getDateTime;
                    return [4 /*yield*/, getFirstTime()];
                case 4:
                    _c = _b.apply(void 0, [(_l.sent())]);
                    _d = getDateTime;
                    return [4 /*yield*/, getSecondTime()];
                case 5:
                    if (_c < _d.apply(void 0, [(_l.sent())]))
                        return [2 /*return*/, ''];
                    return [4 /*yield*/, getCurrentTime()];
                case 6:
                    if (!((_l.sent()) === 'first')) return [3 /*break*/, 8];
                    _f = (_e = errorGenerators).timeBefore;
                    _g = [language];
                    return [4 /*yield*/, getSecondTime()];
                case 7: return [2 /*return*/, _f.apply(_e, _g.concat([(_l.sent())]))];
                case 8: return [4 /*yield*/, getCurrentTime()];
                case 9:
                    if (!((_l.sent()) === 'second')) return [3 /*break*/, 11];
                    _j = (_h = errorGenerators).timeAfter;
                    _k = [language];
                    return [4 /*yield*/, getFirstTime()];
                case 10: return [2 /*return*/, _j.apply(_h, _k.concat([(_l.sent())]))];
                case 11: return [2 /*return*/, ''];
            }
        });
    }); }, [language]);
    var onOk = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0: return [4 /*yield*/, getCurrentTime()];
                case 1:
                    _a = (_o.sent()) === 'first';
                    if (!_a) return [3 /*break*/, 3];
                    return [4 /*yield*/, getFirstTime()];
                case 2:
                    _a = !(_o.sent());
                    _o.label = 3;
                case 3:
                    if (!_a) return [3 /*break*/, 5];
                    return [4 /*yield*/, setFirstTime(new Date())];
                case 4:
                    _o.sent();
                    _o.label = 5;
                case 5: return [4 /*yield*/, getCurrentTime()];
                case 6:
                    _b = (_o.sent()) === 'second';
                    if (!_b) return [3 /*break*/, 8];
                    return [4 /*yield*/, getSecondTime()];
                case 7:
                    _b = !(_o.sent());
                    _o.label = 8;
                case 8:
                    if (!_b) return [3 /*break*/, 11];
                    _c = setSecondTime;
                    return [4 /*yield*/, getFirstTime()];
                case 9: return [4 /*yield*/, _c.apply(void 0, [(_l = _o.sent()) !== null && _l !== void 0 ? _l : new Date()])];
                case 10:
                    _o.sent();
                    _o.label = 11;
                case 11: return [4 /*yield*/, getCurrentTime()];
                case 12:
                    _d = (_o.sent()) === 'first';
                    if (!_d) return [3 /*break*/, 14];
                    return [4 /*yield*/, getSecondTime()];
                case 13:
                    _d = !(_o.sent());
                    _o.label = 14;
                case 14:
                    if (_d)
                        return [2 /*return*/, setCurrentTime('second')];
                    return [4 /*yield*/, getCurrentTime()];
                case 15:
                    _e = (_o.sent()) === 'second';
                    if (!_e) return [3 /*break*/, 17];
                    return [4 /*yield*/, getFirstTime()];
                case 16:
                    _e = !(_o.sent());
                    _o.label = 17;
                case 17:
                    if (_e)
                        return [2 /*return*/, setCurrentTime('first')];
                    return [4 /*yield*/, generateError()];
                case 18:
                    if (_o.sent())
                        return [2 /*return*/];
                    _g = (_f = form).setFieldValue;
                    _h = [id];
                    return [4 /*yield*/, getFirstTime()];
                case 19:
                    _j = [_o.sent()];
                    return [4 /*yield*/, getSecondTime()];
                case 20:
                    if (!((_m = _o.sent()) !== null && _m !== void 0)) return [3 /*break*/, 21];
                    _k = _m;
                    return [3 /*break*/, 23];
                case 21: return [4 /*yield*/, getFirstTime()];
                case 22:
                    _k = _o.sent();
                    _o.label = 23;
                case 23:
                    _g.apply(_f, _h.concat([_j.concat([_k])]));
                    setIsOpen(false);
                    return [2 /*return*/];
            }
        });
    }); }, [form, error, id]);
    var onExited = useCallback(function () {
        setFirstTime(null);
        setSecondTime(null);
        setCurrentTime('first');
    }, []);
    useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setError;
                    return [4 /*yield*/, generateError()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
            }
        });
    }); }, [firstTime, secondTime, currentTime]);
    return (_jsxs(_Fragment, { children: [_jsx(FormInput, __assign({ id: id, endAdornment: (_jsx(IconButton, __assign({ color: "primary", className: formFileClasses.iconButton }, { children: _jsx(AccessTimeIcon, { className: formFileClasses.svg }, void 0) }), void 0)), readOnly: true }, rest, { classes: __assign(__assign({}, formInputClasses), { input: clsx(formInputClasses.input, value !== ctr && classes.input) }), onClick: onOpen, disabled: disabled, value: value }), void 0),
            _jsxs(Dialog, __assign({ open: isOpen && !disabled, onExited: onExited }, { children: [_jsxs(DialogTitle, __assign({ className: classes.dialogTitle }, { children: [_jsx(Button, __assign({ onClick: function () { return setCurrentTime('first'); }, classes: {
                                    root: classes.timeButton,
                                    label: clsx(classes.timeButtonLabel, currentTime === 'first' && classes.currentLabel)
                                } }, { children: firstTime ? formatTime(firstTime, language) : '00:00' }), void 0),
                            _jsx("span", __assign({ className: classes.timeButtonLabel }, { children: " - " }), void 0),
                            _jsx(Button, __assign({ onClick: function () { return setCurrentTime('second'); }, classes: {
                                    root: classes.timeButton,
                                    label: clsx(classes.timeButtonLabel, currentTime === 'second' && classes.currentLabel)
                                } }, { children: secondTime ? formatTime(secondTime, language) : '00:00' }), void 0)] }), void 0),
                    _jsx(TimePicker, { ampm: false, value: currentTime === 'first' ? firstTime : secondTime, onChange: currentTime === 'first' ? setFirstTime : setSecondTime, variant: "static", TextFieldComponent: function () { return null; } }, currentTime),
                    _jsx(DialogActions, __assign({ className: classes.error }, { children: error }), void 0),
                    _jsxs(DialogActions, { children: [_jsx(Button, __assign({ color: "primary", onClick: onCancel }, { children: "cancel" }), void 0),
                            _jsx(Button, __assign({ color: "primary", className: classes.okButton, onClick: onOk }, { children: "ok" }), void 0)] }, void 0)] }), void 0)] }, void 0));
};
export default FormTimeRange;
var useStyles = makeStyles(function (theme) { return ({
    input: {
        direction: theme.direction
    },
    dialogTitle: {
        direction: theme.direction,
        background: theme.palette.primary.main,
        paddingBottom: 0
    },
    timeButton: {
        padding: 0
    },
    timeButtonLabel: {
        color: 'rgba(255, 255, 255, 0.54)',
        fontSize: 20
    },
    currentLabel: {
        color: 'white'
    },
    error: {
        color: theme.palette.error.main,
        justifyContent: 'flex-start'
    },
    okButton: {
        marginLeft: 8
    }
}); });
//# sourceMappingURL=FormTimeRange.js.map